import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { NodeGroupType, Tag, Tags } from "@/services/cloudchipr.api";
import { TagCell } from "@/components/pages/common/ag-grid/components/common-cell-renderers/tag-cell/TagCell";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { TypographyWithCopy } from "@/components/common/TypographyWithCopy";

export const nodeGroupColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  { field: "resource.instances_count", headerName: "Nodes" },

  {
    field: "resource.type",
    headerName: "Group Type",
    cellRenderer: ({ data }: ICellRendererParams) => {
      const type = data?.resource?.type as NodeGroupType | undefined;

      if (!type) {
        return null;
      }

      return <TypographyWithCopy value={groupTypeLabels[type]} />;
    },
  },

  getResourceCreationTimeColumnDef("Launch Time"),

  {
    minWidth: 210,
    sortable: false,
    field: "resource.labels",
    headerName: "Kubernetes Labels",
    valueGetter: ({ data }) =>
      data?.resource?.labels
        ?.map((label: Tag) => `${label.key}: ${label.value}`)
        ?.join(", "),
    cellRenderer: ({ data }: ICellRendererParams) => {
      const labels = data?.resource?.labels as Tags;

      return (
        <TagCell
          chipColor="success"
          chipVariant="outlined"
          tags={labels ?? []}
        />
      );
    },
  },

  tagsColumnDef,
];

const groupTypeLabels: Record<NodeGroupType, string> = {
  karpenter_node_pool: "Karpenter Node Pool",
  eks_node_group: "EKS Node Group",
};
